<app-page-header [title]="'Mail Statistics'" [subtitle]="'View mail stats and mail notifications'"></app-page-header>
<div class="mb-6">
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        <!-- Total Mails -->
        <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
            <div class="flex items-center gap-4">
                <i class="pi pi-envelope text-blue-500 dark:text-blue-300" style="font-size: 1.7rem"></i>
                <div>
                    <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Mails</p>
                    <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ mailStats?.totalMails || 0 }}</p>
                </div>
            </div>
        </div>

        <!-- Total Deliveries -->
        <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
            <div class="flex items-center gap-4">
                <i class="pi pi-check text-green-500 dark:text-green-300" style="font-size: 1.7rem"></i>
                <div>
                    <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Deliveries</p>
                    <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ mailStats?.totalDeliveries || 0 }}</p>
                </div>
            </div>
        </div>

        <!-- Total Complaints -->
        <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
            <div class="flex items-center gap-4">
                <i class="pi pi-exclamation-triangle text-yellow-500 dark:text-yellow-300"
                   style="font-size: 1.7rem"></i>
                <div>
                    <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Complaints</p>
                    <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ mailStats?.totalComplaints || 0 }}</p>
                </div>
            </div>
        </div>

        <!-- Total Bounces -->
        <div class="bg-black border border-gray-300 dark:border-gray-700 rounded-sm p-4">
            <div class="flex items-center gap-4">
                <i class="pi pi-times-circle text-red-500 dark:text-red-300" style="font-size: 1.7rem"></i>
                <div>
                    <p class="text-sm font-semibold text-gray-500 dark:text-gray-400">Total Bounces</p>
                    <p class="text-2xl font-bold text-gray-800 dark:text-white">{{ mailStats?.totalBounces || 0 }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Mail Notifications</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md">
        <div class="flex justify-between items-center mb-2">
            <!-- Search Input -->
            <p-ifta-label>
                <p-iconfield>
                    <p-inputicon class="pi pi-search"></p-inputicon>
                    <input
                            pInputText
                            id="mail_notification_search"
                            [(ngModel)]="search"
                            (input)="onSearchInputChange()"
                            autocomplete="off"
                    />
                </p-iconfield>
                <label for="mail_notification_search">Search Mail Notifications</label>
            </p-ifta-label>

            <!-- Filter Dropdown -->
            <p-select
                    [options]="notificationTypes"
                    [(ngModel)]="selectedType"
                    placeholder="Filter by Type"
                    (onChange)="onTypeFilterChange()"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"
            ></p-select>
        </div>

        <!-- Table -->
        <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
            <p-table
                    [value]="mailNotifications"
                    [paginator]="true"
                    [rows]="rows"
                    [totalRecords]="totalRecords"
                    [lazy]="true"
                    [first]="currentPage * rows"
                    [loading]="loading"
                    [rowsPerPageOptions]="[5, 10, 20]"
                    (onLazyLoad)="onPageChange($event)"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Recipient</th>
                        <th>Sender</th>
                        <th>Type</th>
                        <th>Reason</th>
                        <th>Timestamp</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-notification>
                    <tr>
                        <td>{{ notification.recipient }}</td>
                        <td>{{ notification.sender }}</td>
                        <td>
                            <p-tag
                                    [value]="notification.type | enumLabel"
                                    [severity]="getTagSeverity(notification.type)"
                            ></p-tag>
                        </td>
                        <td>{{ notification.reason }}</td>
                        <td>{{ notification.timestamp | formatDateTime }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

